import React, { useState } from "react";
// import aboutImg from "../assets/Stories_of_change_6_27a930bfca.png";
// import aboutImg from "../assets/WhatsApp Image 2026-02-11 at 6.38.15 PM.jpeg"
import image1 from "../assets/home/main4.jpeg";
import image2 from "../assets/home/main8.jpeg";


const StrengthAccordion = () => {

  const [openIndex, setOpenIndex] = useState(0);

  const data = [
    {
      title: "Flexible and Reliable Service",
      content: [
        "With extensive experience in the field of DGFT (EXIM) consultancy and industrial subsidy facilitation, our team provides flexible and dependable services tailored to each client’s needs.",
        "We understand that every business operates differently, which is why we offer customized solutions that ensure smooth processing of applications and timely approvals from relevant authorities."
      ],
      },
    {
      title: "Strong Brand and Customer Relations",
      content: [
        "Over the years, APEX Consultants has built strong and trusted relationships with businesses across multiple sectors. Our dedication to delivering quality consultancy services has helped us establish a solid reputation in export–import advisory and government incentive facilitation.",
        "We believe that long-term client relationships are built on trust, transparency, and consistent service excellence."
      ],
      },
    {
      title: "Several Years of Operating Experience",
      content: [
        "With more than a decade of experience in consultancy services, our team has developed deep expertise in handling regulatory procedures and government approvals.",
         "Our professionals guide businesses efficiently through DGFT licensing, industrial subsidy applications, compliance requirements, and policy regulations, ensuring smooth operations and long-term growth."
        
      ],
    }
  ];

  return (
    <div className="strength-right">

      {data.map((item, index) => (
        <div
          key={index}
          className={`acc-item ${openIndex === index ? "active" : ""}`}
        >
          <div
            className="acc-title"
            onClick={() => setOpenIndex(index)}
          >
            {item.title}
            <span>{openIndex === index ? "−" : "+"}</span>
          </div>

          {openIndex === index && (
            <div className="acc-content">{item.content}</div>
          )}
        </div>
      ))}

    </div>
  );
};


const About = () => {
  return (
    <div className="about-page">

      {/* HERO HEADER */}
      <section className="about-hero">
        <div className="about-hero-overlay">
          <div className="container">
            <h1>About APEX Consultants</h1>
            <p>Home  ›  About Us</p>
          </div>
        </div>
      </section>


      {/* OVERVIEW SECTION */}
      <section className="about-overview">
        <div className="container1 overview-grid">

          {/* IMAGE SIDE */}
      {/* <div className="overview-image">

  {/* decorative backgrounds 
  <div className="img-bg-shape"></div>
  <div className="img-bg-lines"></div>

  {/* actual image 
  <div className="img-wrapper">
    <img src={image2} alt="about" />
  </div>

  {/* badge 
  <div className="experience-badge">
    <p><span className="me-3">12 +</span>
              Years of Experience<br />In Services</p>
              <p>With over a decade of expertise, APEX Consultants helps industries secure DGFT approvals, industrial subsidies, and regulatory clearances efficiently.</p>
            </div>

</div> */}
      
      <div className="overview-image">

  {/* Background Shapes */}
  {/* <div className="img-bg-lines"></div>
  <div className="img-bg-shape"></div> */}

  {/* Image */}
  <div className="img-wrapper">
    <img src={image2} alt="about" />
  </div>

  {/* Badge */}
  <div className="experience-badge">
    <h3>12+</h3>
              <p>Years of Experience</p>
                            <p>With over a decade of expertise, APEX Consultants helps industries secure DGFT approvals, industrial subsidies, and regulatory clearances efficiently.</p>

  </div>

</div>



          {/* TEXT SIDE */}
          <div className="overview-text">
           <small className="green-label">OVERVIEW</small>
<h2>APEX Professional Services</h2>

<p>In today’s rapidly evolving business environment, industries and entrepreneurs often face challenges in understanding and complying with complex government regulations, export–import policies, and industrial incentive schemes. Navigating these regulatory frameworks requires professional expertise, proper documentation, and strong liaison with government authorities.</p>
<p>APEX Consultants is committed to providing reliable and result-oriented consultancy services in the areas of DGFT Liaisoning (EXIM), Industrial Subsidies, and Government Incentive Schemes. With extensive industry knowledge and professional experience, we assist businesses in understanding eligibility requirements, obtaining approvals, and ensuring smooth compliance with applicable regulations.</p>
<p>Our team works closely with clients to simplify procedures related to import–export licensing, subsidy approvals, compliance documentation, and regulatory clearances. We focus on helping businesses maximize government benefits while minimizing delays and procedural complexities.</p>
<p>At APEX Consultants, we believe that professional guidance and strategic planning are essential for sustainable business growth. Our objective is to provide transparent, efficient, and reliable services that enable organizations to focus on their core operations while we handle the regulatory processes.</p>
<p>With a strong commitment to quality and professionalism, APEX Consultants continues to support industries across India in accessing government incentives and achieving long-term success.</p>
          </div>

        </div>
      </section>


      {/* DESCRIPTION BLOCK */}
     <section className="about-description section">
  <div className="container1 desc-grid">

    {/* LEFT CONTENT */}
    <div className="desc-text">
      <h2>
        Using our knowledge to inject life into your business is our sole aim.
      </h2>

      <p>
        In every business today, there’s a series of imperatives at work.
        For businesses to grow, they need to operate as efficiently as possible
        and make the best use of available information to stay competitive
        within their markets.
      </p>

      <p>
        This is where APEX Professional Services comes into the picture —
        from educating you about available opportunities to documentation,
        preparation of applications, and coordination with various
        government agencies to achieve your objective, we do it all under one roof.
      </p>

      <p>
        After all, we are here to enrich your business.
      </p>
    </div>

    {/* RIGHT IMAGE */}
    <div className="desc-images">
      <img src={image1} alt="about" />
      {/* <img src={aboutImg} alt="about" /> */}
    </div>

  </div>
</section>


      <section className="about-team section1">
  <div className="container team-content">

    <div className="team-header">
      <small className="green-label">OUR TEAM</small>
      <h2>Meet Our Awesome APEX Services Team Members</h2>
    </div>

    <div className="team-grid">

      <div>
        <p>With over a decade of professional experience, Mr. Veera Babu leads APEX Consultants with strong expertise in DGFT Liaisoning (EXIM), Industrial Subsidies, and regulatory compliance services. His leadership, industry knowledge, and practical approach have helped numerous businesses successfully obtain government approvals, incentives, and regulatory clearances.</p>
        <p>Under his guidance, APEX Consultants focuses on delivering reliable, transparent, and result-oriented consultancy services. The organization is committed to helping industries navigate complex regulatory procedures while ensuring smooth and efficient processing of applications.</p>
        </div>

      <div>
       <p>Our team consists of skilled professionals who work closely with clients to understand their business requirements and provide tailored consultancy solutions. With a strong commitment to quality service, we continuously strive to exceed client expectations and deliver measurable results.</p>
        <p>Through teamwork, expertise, and dedication, APEX Consultants remains focused on supporting businesses in accessing government incentives, DGFT approvals, and industrial growth opportunities.</p>
      
      </div>

    </div>
  </div>
</section>



      {/* STRENGTHS ACCORDION */}
      <section className="about-strength section1">
  <div className="container strength-grid">

    {/* LEFT SIDE */}
    <div className="strength-left">
      <h2>Strengths</h2>
      
      <h4>Expertise in DGFT & Industrial Subsidies</h4>
    <p>We possess strong experience in handling DGFT (EXIM) matters and industrial subsidy approvals, helping businesses secure government benefits efficiently.</p>

    <h4>Professional and Reliable Services</h4>
    <p> Our team follows a systematic and transparent approach to ensure smooth processing, accurate documentation, and timely project completion.</p>

    <h4>Client-Focused Approach</h4>
    <p>We prioritize understanding our clients’ business needs and provide practical solutions that support long-term growth and compliance.</p>

    <h4>Flexible and Responsive Support</h4>
    <p>With industry experience and dedicated support, we ensure prompt responses and efficient handling of regulatory procedures.</p>
    </div>

    {/* RIGHT SIDE (accordion wrapper) */}
    <StrengthAccordion />
          </div>
</section>

    </div>
  );
};

export default About;
